/* istanbul ignore file */
import {CustomCssVarsFn} from '@wix/yoshi-flow-editor';
import {Alignment} from '../../productPage/constants';

type CustomCssVarsFnParams = Omit<Parameters<CustomCssVarsFn>[0], 'tpaData'>;

const enum FlexAlignment {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
}

export const customCssVars = ({styleParams, isRTL}: CustomCssVarsFnParams) => {
  const getErrorMessageAlignment = () => {
    const defaultAlignmentRtl = isRTL ? Alignment.RIGHT : Alignment.LEFT;
    switch (styleParams.strings.productPage_productDetailsAlignment?.value || defaultAlignmentRtl) {
      case Alignment.LEFT:
        return isRTL ? FlexAlignment.FlexEnd : FlexAlignment.FlexStart;
      case Alignment.RIGHT:
        return isRTL ? FlexAlignment.FlexStart : FlexAlignment.FlexEnd;
      case Alignment.CENTER:
        return FlexAlignment.Center;
    }
  };

  return {
    errorMessageFlexAlignment: getErrorMessageAlignment(),
    imageGalleryPaginationDotsDirection: isRTL ? 'row-reverse' : 'row',
    infoSectionCollapseIconOrder: isRTL ? '0' : '1',
    infoSectionCollapseTitleOrder: isRTL ? '1' : '0',
    infoSectionDirection: isRTL ? 'rtl' : 'ltr',
  };
};
